import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.text.primary, // for consistency with other setting page subtitles
    marginBottom: 20,
  },
  label: {
    marginRight: theme.spacing(1.25),
    color: theme.palette.text.primary,
  },
  heading: {
    marginBottom: 5,
  },
}));
